let cachedProof = null;
let proofRequest = null;

async function requestProof() {
  const response = await fetch("/api/form-proof", {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) throw new Error("Form session unavailable");
  const result = await response.json();
  if (!result?.ok || !result?.token) {
    throw new Error("Form session unavailable");
  }
  cachedProof = {
    token: result.token,
    expiresAt: Date.now() + Number(result.expiresInMs || 0),
    usableAt: Date.now() + 800,
  };
  return cachedProof;
}

export async function getFormProofFields() {
  let proof = cachedProof;
  if (!proof || proof.expiresAt - Date.now() <= 60_000) {
    if (!proofRequest) {
      proofRequest = requestProof().finally(() => {
        proofRequest = null;
      });
    }
    proof = await proofRequest;
  }
  const waitMs = Math.max(0, proof.usableAt - Date.now());
  if (waitMs) {
    await new Promise((resolve) => setTimeout(resolve, waitMs));
  }
  return { _formProof: proof.token };
}

export function primeFormProof() {
  getFormProofFields().catch(() => {
    // A later submit retries. Do not interrupt page rendering for a warm-up.
  });
}

